import { Switch } from 'antd';

export const Toggle: React.FC<{
    onChange?: (value: boolean) => void;
    value?: boolean;
    disabled?: boolean;
}> = ({ onChange, value, disabled }) => {
    return <Switch checked={value} onChange={onChange} disabled={disabled} />;
};
